export const reactRouterUtility = {
    navigate: null,
    location: null,
    forceUpdate :null
};